/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerFindAllQueryResponse, ProjectsControllerFindAllQueryParams, ProjectsControllerFindAll401, ProjectsControllerFindAll403 } from "../../models/projectsController/ProjectsControllerFindAll";

function getProjectsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/projects` as const }  
  return res
}

/**
 * @summary Get all projects for the current user
 * {@link /api/v1/projects}
 */
export async function projectsControllerFindAll(params?: ProjectsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectsControllerFindAllQueryResponse, ResponseErrorConfig<ProjectsControllerFindAll401 | ProjectsControllerFindAll403>, unknown>({ method : "GET", url : getProjectsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}